import { useState } from 'react';
import { ICustomerItemData } from 'services/shop/types/customer';
import ModalChooseCustomer from 'widgets/Customer/ModalChooseCustomer';
import refresh_icon from './icons/refresh.svg';
import styled from 'styled-components';
import Edit from 'assets/Icons/edit';
type Props = {
  onPickCustomer: (customer: ICustomerItemData) => void;
};
const TicketEditCustomer = ({ onPickCustomer }: Props) => {
  const [visible, setVisible] = useState(false);
  const onOpenChangeCustomer = () => {
    setVisible(true);
  };

  const handlePickCustomer = (customer: ICustomerItemData) => {
    onPickCustomer(customer);
    setVisible(false);
  };

  return (
    <>
      <ButtonRefresh type='button' className='button-refresh' onClick={onOpenChangeCustomer}>
        <Edit fill='#4384ff' style={{ width: 38, height: 38 }} />
      </ButtonRefresh>
      <ModalChooseCustomer
        v2
        visible={visible}
        onClose={() => setVisible(false)}
        onPickCustomer={handlePickCustomer}
      />
    </>
  );
};

export default TicketEditCustomer;

const ButtonRefresh = styled.button`
  border-radius: 4px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`;